export const RECAPTCHA_SECRET = '6Ld0_kQUAAAAAGKKsu9kdClfeL0fAgLQq5zbmqRt'
export const FORM_TYPE_CONTACTUS = 'contact_us'
export const FORM_TYPE_NEWSLETTER = 'newsletter'

export const RATING_TYPE_OUR_RATING = 'our_rating'
